<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="B2">
    <!-- Main fields -->
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">Benefits Contact Information</div>
            <div class="text-subtitle-1">Please provide the main contact information for whoever is handling benefits.</div>
          </v-col>

          <!-- Contact Name -->
          <v-col cols="12">
            <v-text-field
              id="NoOverflow"
              outlined
              label="Contact name"
              class="rounded-lg"
              hide-details
              v-model="contact.contactName"
            ></v-text-field>
          </v-col>

          <!-- Contact Email -->
          <v-col cols="12" sm="6">
            <v-text-field
              id="NoOverflow"
              outlined
              label="Contact email address"
              class="rounded-lg"
              hide-details
              v-model="contact.contactEmail"
            ></v-text-field>
          </v-col>

          <!-- Contact Phone -->
          <v-col cols="12" sm="6">
            <v-text-field
              id="NoOverflow"
              outlined
              label="Contact phone number"
              class="rounded-lg"
              hide-details
              v-model="contact.contactPhone"
            ></v-text-field>
          </v-col>
          <BenefitsBtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BenefitsBtnContinue from './btnBenefitsContinue.vue';

export default {
  name: 'BenefitsStepTwo',
  components: {
    BenefitsBtnContinue,
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    benefitsProvided() {
      return this.$store.state.benefitsPacket.flags.benefitsAlreadyProvided;
    },
    providers: {
      get() {
        return this.$store.state.benefitsPacket.providers;
      },
      set(value) {
        this.$store.commit('updateBenefitsProviders', value);
      },
    },
    contact: {
      get() {
        return this.$store.state.benefitsPacket.contact;
      },
      set(value) {
        this.$store.commit('updateBenefitsContact', value);
      },
    },
  },
  methods: {
    download() {
      this.downloadClicked = true;
    },
    clearHealthProvider() {
      if (!this.benefitsProvided) {
        this.providers.health = 'N/A';
      } else {
        this.providers.health = null;
      }
    },
  },
};
</script>

<style lang="scss">
label[for="NoOverflow"] {
  overflow: unset !important;
}
</style>
